import { render, staticRenderFns } from "./EmployeeReports.vue?vue&type=template&id=67b5664e&"
import script from "./EmployeeReports.vue?vue&type=script&lang=js&"
export * from "./EmployeeReports.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeReports.vue?vue&type=style&index=0&id=67b5664e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports